export const convertToUTC = (date: Date | string): Date => {
  const d = new Date(date);
  return new Date(d.getTime() + d.getTimezoneOffset() * 60000);
};

export const utcDateNow = convertToUTC(new Date());

export const not72HoursWindow = (date: string): boolean => {
  const utcDepartureDate = convertToUTC(date);
  return (utcDepartureDate.getTime() - utcDateNow.getTime()) / 3600000 > 72;
};

/**
 * Parses an ISO date string and returns a formatted date string
 * that is timezone-neutral (uses the date as-is from the string).
 * This prevents date shifting when displayed in different timezones.
 * @param dateString - ISO date string (e.g., '2025-03-20T07:59:00-04:00')
 * @returns Formatted date string (e.g., 'Thu Mar 20 2025')
 */
export const getTimezoneNeutralDate = (dateString: string): string => {
  const datePart = dateString.split('T')[0];
  const [year, month, day] = datePart.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  return date.toDateString();
};
